export default __webpack_public_path__ + "static/media/Rabbit.697209f7.png";